exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_widgets_32GMutA0J_nkNq3s2o9K8h {\n  position: relative;\n  width: 100%;\n  height: auto;\n  float: left;\n}\n\n.IA_filters_2MtTUERGAsr9xWTdrGFaYk {\n  width: 100%;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: row;\n}\n\n.IA_paginationButtonContainer_1OAzp5hiBgWgd9ingxf-lK {\n  width: 100%;\n  height: 30px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.IA_paginationPageCount_3l_qBFMj-9AdzGPISp0jAs {\n  text-align: center;\n}", ""]);

// Exports
exports.locals = {
	"IA_widgets": "IA_widgets_32GMutA0J_nkNq3s2o9K8h",
	"IA_filters": "IA_filters_2MtTUERGAsr9xWTdrGFaYk",
	"IA_paginationButtonContainer": "IA_paginationButtonContainer_1OAzp5hiBgWgd9ingxf-lK",
	"IA_paginationPageCount": "IA_paginationPageCount_3l_qBFMj-9AdzGPISp0jAs"
};